import { Component, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AutoLogoutService } from './services/autologout.service';
import { AuthService } from './auth/auth.service';
import { Observable, observable, Subject} from 'rxjs';
export class MyDataType {
  public id: number;
  public name: string;
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  private destroy$ = new Subject<void>();
  title = 'blogger';
  checked: boolean;
  public result: any;
  public shareResult$: Observable<" ">;
  mydata: MyDataType[] = [
    {"id":1, "name":"Aleja"},
    {"id":2, "name":"Giraldo"}
  ];

  constructor(public router: Router, private service: AutoLogoutService, private auth: AuthService) {}

  ngOnInit() {
    // A sign-in that happened on the web portal hands its token over in the URL
    // fragment; pick it up before any guard or interceptor runs.
    if (this.auth.adoptSessionFromUrl()) {
      this.router.navigate(['/admin/dashboard']);
    }
    this.getUsersForSubscription();
  }
  getUsersForSubscription():Observable<MyDataType[]>
  {
    let data = new Observable<MyDataType[]>(observer => {
          setTimeout(() => {
            observer.next(this.mydata);
          }, 2000);
    });
    return data;
  }
  public multiplcation(num1,num2) {
    this.result =num1 * num2;
    //this.shareResult$.next
  }
  public useObservable() {
    this.shareResult$.pipe(takeUntil(this.destroy$)).subscribe(res=>{
    })
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
